/**
 * Audio utilities for Comments component
 * Handles notification sounds for new comments and upvotes
 */

/**
 * Creates and plays a notification sound for new comments
 * @param {AudioContext} audioContext - Web Audio API context
 */
export const playNotificationSound = (audioContext) => {
  if (!audioContext) return;

  try {
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.setValueAtTime(800, audioContext.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(600, audioContext.currentTime + 0.1);

    gainNode.gain.setValueAtTime(0.1, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.1);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.1);
  } catch (error) {
    console.log('Audio notification error:', error);
  }
};

/**
 * Creates and plays a notification sound for upvotes
 * @param {AudioContext} audioContext - Web Audio API context
 */
export const playUpvoteNotificationSound = (audioContext) => {
  if (!audioContext) return;

  try {
    if (audioContext.state === 'suspended') {
      audioContext.resume();
    }

    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    oscillator.frequency.setValueAtTime(600, audioContext.currentTime);
    oscillator.frequency.exponentialRampToValueAtTime(1000, audioContext.currentTime + 0.15);

    gainNode.gain.setValueAtTime(0.08, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.15);

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.15);
  } catch (error) {
    console.log('Audio notification error:', error);
  }
};

/**
 * Initializes AudioContext for the component
 * @returns {AudioContext|null} AudioContext instance or null if not available
 */
export const initializeAudioContext = () => {
  try {
    return new (window.AudioContext || window.webkitAudioContext)();
  } catch (error) {
    console.log('AudioContext not available:', error);
    return null;
  }
};
